/**
 * 埋点数据上报工具
 * 用于记录用户行为数据到数据库
 */

import axios from 'axios';

// 事件类型常量
export const EVENT_TYPE = {
  ROUTE: 1,    // 路由访问
  BUTTON: 2    // 按钮点击
};

// 全局用户信息存储
let globalUserInfo = {
  userId: null,
  email: null
};

/**
 * 设置全局用户信息
 * @param {Object} userInfo - 用户信息
 * @param {number} userInfo.userId - 用户ID
 * @param {string} userInfo.email - 用户邮箱
 */
export const setGlobalUserInfo = (userInfo) => {
  if (userInfo) {
    globalUserInfo.userId = userInfo.userId || userInfo.id;
    globalUserInfo.email = userInfo.email;
  } else {
    globalUserInfo.userId = null;
    globalUserInfo.email = null;
  }
};

/**
 * 获取全局用户信息
 * @returns {Object} 用户信息
 */
export const getGlobalUserInfo = () => {
  return { ...globalUserInfo };
};

/**
 * 上报埋点数据到数据库
 * @param {Object} params - 埋点参数
 * @param {number} params.event_type - 事件类型（1:路由, 2:按钮）
 * @param {string} params.event_name - 事件名称
 * @param {string} params.content - 事件内容（可选）
 * @returns {Promise<boolean>} 返回上报是否成功
 */
export const reportBury = async (params) => {
  try {
    const { event_type, content = '' } = params;

    // 验证必填字段
    if (!event_type) {
      console.error('埋点上报失败：缺少必填字段 event_type');
      return false;
    }
    // 获取全局用户信息
    const userInfo = getGlobalUserInfo();
    
    // 发送到后端 API
    const response = await axios.post('/api/bury/report', {
      events: [{
        path: window.location.pathname,
        event_type,
        content,
        timestamp: new Date().toISOString(),
        userId: userInfo.userId,
        email: userInfo.email
      }]
    });

    if (response.data.success) {
      console.log('✅ 埋点上报成功');
      return true;
    } else {
      console.error('❌ 埋点上报失败:', response.data.error);
      return false;
    }
  } catch (error) {
    console.error('❌ 埋点上报失败:', error.message);
    return false;
  }
};


/**
 * 上报埋点数据（通用方法）
 * @param {number} eventType - 事件类型（1:路由, 2:按钮）
 * @param {string} eventInfo - 事件信息（可选）
 */
export const reportData = (eventType, eventInfo = '') => {
  return reportBury({
    event_type: eventType,
    content: eventInfo,
  });
};
